import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ExploreContentRequest } from '../../ts/ServerApi/requests/ExploreContentRequest';
import { ExploreFavoritedContentForUserRequest } from '../../ts/ServerApi/requests/ExploreFavoritedContentForUserRequest';
import { GetContentForUserRequest } from '../../ts/ServerApi/requests/GetContentForUserRequest';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ExploreFavoriteContentForUserRequest } from '../../ts/ServerApi/requests/ExploreFavoriteContentForUserRequest';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ServerFilterClauses } from '../../ts/helpers/ServerFilterClauses';

class ContentResource {

  private exploreContentFetcher: IListFetcher<IContentInfo>;
  private exploreFavoritedContentForUser: IListFetcher<IContentInfo>;
  private exploreFavoriteContentForUser: IListFetcher<IContentInfo>;
  private getContentForUserFetcher: IListFetcher<IContentInfo>;

  constructor() {
    this.exploreContentFetcher = new WebClientListResourceFetcher(ExploreContentRequest, ServerApiMapper.content);
    this.exploreFavoritedContentForUser = new WebClientListResourceFetcher(ExploreFavoritedContentForUserRequest, ServerApiMapper.content);
    this.exploreFavoriteContentForUser = new WebClientListResourceFetcher(ExploreFavoriteContentForUserRequest, ServerApiMapper.favoriteFromCrass);
    this.getContentForUserFetcher = new WebClientListResourceFetcher(GetContentForUserRequest, ServerApiMapper.content);
  }

  public forProject(projectId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreContentFetcher)
      .withExtraParams({ 'project': projectId })
      .withFilters(additionalFilterClauses);
  }

  public forPersonalSpace(ownerId: string, additionalFilterClauses: ILeafFilterClause[]): ResourceQuery<IContentInfo>{
    return new ResourceQuery(this.exploreContentFetcher)
      .withFilters(additionalFilterClauses.concat([
        ServerFilterClauses.serverFilterClauses.owner(ownerId),
        ServerFilterClauses.serverFilterClauses.usersPersonalSpaceContent('true')]));
  }

  public forUser(userId: string, additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher)
      .withExtraParams({ 'userId': userId })
      .withFilters(additionalFilterClauses);
  }

  public forFavorites(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoritedContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forFavoritesFromCRASS(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.exploreFavoriteContentForUser)
      .withFilters(additionalFilterClauses);
  }

  public forCurrentUser(additionalFilterClauses?: ILeafFilterClause[]): ResourceQuery<IContentInfo> {
    return new ResourceQuery(this.getContentForUserFetcher).withFilters(additionalFilterClauses);
  }

}

export const Content = new ContentResource;
